import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle, FaCogs, FaHandsHelping } from "react-icons/fa";
import baba from "../Assets/baba.jpg";

const Whyme = () => {
  return (
    <div className="container-fluid py-5 white-color black-bg" id="a propos">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 mb-3">
            <motion.div
              className="text-section"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <h1 className="mb-4">Pourquoi Travailler Avec Moi ?</h1>
              <p className="fs-5 mb-4">Un accompagnement 100% personnalisé.</p>
              <ul className="fs-5 list-unstyled">
                <li className="mb-3">
                  <FaCheckCircle className="me-3 blue-color" /> Expérience &
                  expertise : Plus de 10 projets réalisés.
                </li>
                <li className="mb-3">
                  <FaCogs className="me-3 blue-color" /> Focus sur la
                  performance : Des sites rapides et optimisés pour la
                  conversion.
                </li>
                <li className="mb-3">
                  <FaHandsHelping className="me-3 blue-color" /> Processus clair
                  & efficace : De la conception à la mise en ligne, sans stress.
                </li>
                <li className="mb-3">
                  <FaHandsHelping className="me-3 blue-color" /> Support &
                  évolutivité : Toute modification après livraison est possible
                  (Facturable).
                </li>
              </ul>
              <h3 className="mt-5">Votre succès en ligne commence ici.</h3>
              <motion.button
                className="btn btn-primary rounded-pill px-4 py-2 "
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <a
                  href="https://tally.so/r/m6vN5o"
                  target="blank"
                  className="white-color text-decoration-none"
                >
                  {" "}
                  Échangeons sur votre projet
                </a>
              </motion.button>
            </motion.div>
          </div>
          <div className="col-lg-6 col-md-12">
            <motion.img
              src={baba}
              alt="Illustration"
              className="img-fluid rounded shadow"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Whyme;
